<script setup lang="ts">
// Panneau fourni à la Fondation (provide('loginExpandedComponent')) : rendu dans
// les 3/4 droite de l'écran de connexion quand le mode étendu est actif. Il
// affiche le formulaire d'inscription en mode « embedded » (sans panneau image
// propre — le col image de gauche de la Fondation reste à gauche et rétrécit).
import AdmissionForm from '@/views/public/admission-form.vue';
import { loginExpanded } from '@/composables/useLoginInscription';
</script>

<template>
  <AdmissionForm embedded @close="loginExpanded = false" />
</template>
